import { CTA } from "@/ui";
import { parseISO, formatDistanceToNowStrict } from "date-fns";
import { formatSalary } from "@/functions/formatSalary";
import { trimText } from "@/functions/trimText";
import { jobs_helper } from "@/helpers/jobs_helper";
import { employer_helper } from "@/helpers/employer_helper";
import { branded_job_ads } from "@/helpers/branded_job_ads";
import classes from "./styles.module.scss";
import clsx from "classnames";
import ArrowRight from "@/assets/ArrowRight.svg";
import { Button } from "react-bootstrap";

export default function JobsResults({ jobs }) {
  if (!jobs || jobs.length === 0) {
    return <p>Sorry, we couldn't find any jobs matching your search.</p>;
  }

  return (
    <>
      {jobs.map((job, index) => {
        let logo = null;
        const [employerID] = jobs_helper.getCategoryValueIds("1df83e15-03f4-4ce7-9f8d-9b20d0ea1538", job);
        const [brandID] = jobs_helper.getCategoryValueIds("2af5dce1-01c9-4f09-9fcd-470dfef8cebb", job);

        if (employerID) {
          const employer = employer_helper.find(employerID, "id");
          logo = employer?.logo || null;
        } else if (brandID) {
          const brand = branded_job_ads.find(brandID, "id");
          logo = brand?.logo || null;
        }

        return (
          <div key={index} className={clsx("js-result js-panel-border", classes.result)}>
            <div className={clsx("js-result-title", logo && "has-logo", classes["result-title"])}>
              <a href={`/jobs/${job.url_slug}/`}>{job.title}</a>
            </div>
            <div className={clsx("js-result-details", classes["result-details"])}>
              {job.addresses && (
                <div className={clsx("js-results-details-location", classes["results-details-location"])}>
                  {job.addresses}
                </div>
              )}
              {job.salary_package && (
                <div className={clsx("js-results-details-salary-package", classes["results-details-salary-package"])}>
                  {formatSalary(job.salary_package)}
                </div>
              )}
            </div>
            {job.description && (
              <div
                className={clsx("js-result-description", classes["result-description"])}
                dangerouslySetInnerHTML={{ __html: trimText(job.description, 300) }}
              />
            )}
            <div class="js-result-links">
              {logo && <img className="js-results-details-employer-logo" src={logo} alt="" />}
              <time className="me-auto">
                {job.published_at
                  ? `Posted ${formatDistanceToNowStrict(parseISO(job.published_at))} ago`
                  : "Posted date not available"}
              </time>

              {/* issue on page first click jump */}
              {/* <CTA href={`/jobs/${job.url_slug}/`} label="View job" variant="secondary" />
              <CTA href={`/jobs/${job.url_slug}/#Apply`} label="Apply now" variant="outline-secondary" /> */}
              <Button href={`/jobs/${job.url_slug}/`} className="btn-secondary new-button">
                View job
                <ArrowRight />
              </Button>
              <div className={["cta"]}>
                <a role="button" href={`/jobs/${job.url_slug}/#Apply`} className="btn btn-outline-secondary new-button">
                  Apply now <ArrowRight />
                </a>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
